<app-page-header [heading]="'Sales List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class=" row ">
    <div class="col-lg-4 "><input (click)="checkcheck()" [checked]="checked" class="text-center"
                                  type="checkbox">&nbsp;&nbsp;Show pending payments
    </div>
    <div class="col-lg-4 d-flex justify-content-end align-items-center">
      <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/sale/add-sale"
         title="Create new sale">&nbsp;<i
        class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
    </div>

    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="sale.search_sale" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Customer Name/Invoice no/Invoice Date..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="sale.search_sale != ''" class="fa fa-close"></i>
            <i *ngIf="sale.search_sale == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%">Sl#</th>
        <th width="11%">Invoice Number</th>
        <th>Customer Name</th>
        <th width=10%>Invoice Date</th>
        <th>Location</th>
        <th width=10%>Total Amount</th>
        <th width=10%>Amount Received Date</th>
        <th width=10%>Received Amount</th>
        <th width=20%>Action</th>
      </tr>
      <tr *ngIf="(sale_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let sale of sale_data;let i=index" style="font-size: 12px">
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ i + 1 }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ sale.INVOICE_NUMBER }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0">
          {{ sale.PATIENT_NAME }}
          <div
            *ngIf="sale.ONLINE_REMARK != '' || sale.ONLINE_REMARK != 'null' ||  sale.ONLINE_REMARK  != null">
            Remarks&nbsp;:&nbsp;{{ sale.ONLINE_REMARK }}
          </div>
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ utils.date(sale.SALE_DATE) }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0">
          {{ sale.STATE_NAME }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ round((sale.TOTAL_AMOUNT) - sale.DISCOUNT) }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ sale.PAYMENT_CREDIT_DATE }}
        </td>
        <td [class.text-danger]="sale.CANCEL_INVOICE == 1"
            [class.text-success]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0"
            [class.text-voilet]="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 1 || sale.FINALIZE == 1 && sale.PAYMENT_CREDIT == 0"
            class="text-center">
          {{ round(sale.RECEIVED_AMOUNT) }}
        </td>
        <td class="text-center">
          <button (click)="sale_items(sale.SALE_ID);open(content);" alt="View" class="btn btn-xs btn-margin btn-info"
                  style="font-size:10px"
                  title="View"><i
            class="fa fa-eye"></i></button>&nbsp;&nbsp;
          <button (click)="sale_items(sale.SALE_ID);opens(files);" alt="Files" class="btn btn-xs btn-margin btn-info"
                  style="font-size:10px"
                  title="Files"><i class="fa fa-file"></i></button>
          <ng-container *ngIf="sale.FINALIZE == 0 &&  sale.CANCEL_INVOICE == 0">
            &nbsp;&nbsp;<a alt="Edit" class="btn btn-xs btn-margin btn-info"
                           routerLink="/sale/add-sale/edit/{{sale.SALE_ID}}" style="font-size:10px;" title="Edit"><i
            class="fa fa-edit"></i></a>
            &nbsp;&nbsp;<button
            (click)="sale_items(sale.SALE_ID);opens(payment);payment_pop(sale.SALE_ID,sale.TOTAL_AMOUNT)"
            alt="Payment credit" class="btn btn-xs btn-margin btn-info"
            style="font-size:10px;"
            title="Payment credit">
            <i
              class="fa fa-rupee"></i></button>
          </ng-container>
          <ng-container
            *ngIf="sale.PAYMENT_CREDIT == 1 && sale.FINALIZE == 0 && sale.CANCEL_INVOICE == 0">
            &nbsp;&nbsp;<button (click)="finalize(sale.SALE_ID)" alt="Finalize" class="btn btn-xs btn-margin btn-info"
                                style="font-size:10px;" title="Finalize"><i
            class="fa fa-check"></i></button>
          </ng-container>
          &nbsp;&nbsp;<button (click)="open_copy(copydata);getSale(sale.SALE_ID)" alt="Copy"
                              class="btn btn-xs btn-margin btn-info"
                              style="font-size:10px;"
                              title="Copy"><i class="fa fa-clone"></i></button>
          <ng-container
            *ngIf="sale.FINALIZE == 0 &&  sale.CANCEL_INVOICE == 0 && sale.PAYMENT_CREDIT == 0">
            &nbsp;&nbsp;<button (click)="cancel(sale.SALE_ID);opens(cancelreason)" alt="Cancel Invoice"
                                class="btn btn-xs btn-margin btn-info"
                                style="font-size:10px;"
                                title="Cancel Invoice"><i class="fa fa-close"></i></button>
          </ng-container>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="9">
          <label class="col-lg-7 mt-2 text-left" style="font-style: italic;">
            <i class="fa fa-circle text-success" style="font-size: 12px;"></i>&nbsp;&nbsp;Payment Received &nbsp;&nbsp;
            <i class="fa fa-circle text-voilet" style="font-size: 12px;"></i>&nbsp;&nbsp;Finalized &nbsp;&nbsp;
            <i class="fa fa-circle text-danger" style="font-size: 12px;"></i>&nbsp;&nbsp;Cancelled
          </label>
        </td>
      </tr>
      </tfoot>
    </table>

    <app-pagination (pageChange)="getSaleList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>

  </div>
</div>


<ng-template #content let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h4 class="modal-title" id="modal-basic-title">
          Sales List
      </h4>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button (click)="opens(sendmail);" *ngIf="saled && saled.CANCEL_INVOICE == '0'"
              class="btn btn-info btn-sm" title="Send to Mail"><i
        class="fa fa-envelope"></i></button>&nbsp;&nbsp;
      <button class="btn  btn-info btn-sm ng-star-inserted" ngxPrint
              printSectionId="printInvoice" title="Print">
        <i class="fa fa-print"></i>&nbsp;Print&nbsp;
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="a4-page">
      <div id="printInvoice">
        <div
          *ngIf="saled"
          style="font-size: 12px; font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';">
          <!--Header-->
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <div style="align-items: center;justify-content: flex-start;display: flex;">
              <ng-container *ngIf="institution.INSTITUTION_LOGO">
                <img alt="institution-logo" width="150" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" style="object-fit: contain;display: block;margin-left: 0;width: auto"
                     >
              </ng-container>
            </div>
            <div>
              <ng-container *ngIf="institution">
                <h5 style="font-size: 16px;font-weight: bold;margin: 0">{{ institution.INSTITUTION_NAME }}</h5>
                <div style="font-size: 12px;line-height: 20px;margin-top: 15px">{{ institution.INSTITUTION_ADDRESS }}
                  <br/>
                  {{ institution.INSTITUTION_CITY }},&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }} <br/>
                  Ph:&nbsp;{{ institution.INSTITUTION_PHONE_NO }}<br/>
                  Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}<br/>
                  VAT IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}
                </div>
              </ng-container>
            </div>
          </div>
          <!-- invoice heading-->
          <div style="font-size: 22px;font-weight: bold;padding: 15px;text-align: center;width: 100%">TAX INVOICE</div>

          <!--invoice and customer details-->
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <!--customer details-->
            <div style="padding-right: 45px;">
              <div style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Customer</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ saled.CUSTOMER_NAME }}
                  <ng-container *ngIf="saled.CUSTOMER_ADDRESS">,{{ saled.CUSTOMER_ADDRESS }}</ng-container>
                  <ng-container *ngIf="saled.CUSTOMER_PHONE">,{{ saled.CUSTOMER_PHONE }}</ng-container>
                </p>
              </div>

              <div *ngIf="saled.VAT_NO" style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">VAT No</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ saled.VAT_NO }}</p>
              </div>

              <div *ngIf="saled.PAYMENT_TYPE"
                   style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Payment Type</p>
                <span>:&nbsp;&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">
                  <ng-container *ngIf="saled.PAYMENT_TYPE == '1'">Cash</ng-container>
                  <ng-container *ngIf="saled.PAYMENT_TYPE == '0'">Card</ng-container>
                  <ng-container *ngIf="saled.PAYMENT_TYPE == '2'">Cheque</ng-container>
                  <ng-container *ngIf="saled.PAYMENT_TYPE == '3'">Bank</ng-container>
                </p>
              </div>
            </div>

            <!--invoice details-->
            <div>
              <div *ngIf="saled.CANCEL_INVOICE == '1'" style="align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Invoice Cancelled</p>
              </div>

              <div *ngIf="saled.INVOICE_NUMBER"
                   style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Invoice No</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ saled.INVOICE_NUMBER }}</p>
              </div>

              <div *ngIf="saled.SALE_DATE"
                   style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Invoice Date</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ utils.date(saled.SALE_DATE) }}</p>
              </div>
            </div>
          </div>
          <div>
            <!--particulars-->
            <table
              style="width: 100%;border: 1px solid black;margin-top: 40px;border-collapse: collapse;border-radius: 0;">
              <thead>
              <tr style="border: 1px solid  #dee2e6;color: #000;">
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;width:3%;">
                  #
                </th>
                <th style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Item
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;width:9%;">
                  HSN
                  Code
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:6%;">
                  MRP
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:6%;">
                  Rate
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:4%;">
                  Qty
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:5%;">
                  UOM
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:6%;">
                  Price
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:6%;">
                  VAT
                  %
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:8%;">
                  VAT Amt
                </th>
                <th *ngIf="total_flood > 0"
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:6%;">
                  F.
                  Cess
                </th>
                <th
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;width:6%;">
                  Total
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of item_list;let i=index" style="border: 1px solid  #dee2e6; ">
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">{{ i + 1 }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;"> {{ item.TRADE_NAME }}
                  <ng-container
                    *ngIf="item.MARK_FOC == 1">&nbsp;(Freebie)
                  </ng-container>
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">{{ item.HSN_CODE }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.MRP }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.UNIT_PRICE | number:'1.2-2' }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.QUANTITY }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.SHORT_FORM }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.PRICE | number:'1.2-2'  }}
                </td>
                <ng-container *ngIf="saled && saled.TIN_NUMBER  != '32'">
                  <td
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.VAT| number:'1.2-2'  }}
                  </td>
                </ng-container>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.VAT_AMOUNT | number:'1.2-2'  }}
                </td>
                <td *ngIf="total_flood > 0"
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ item.FLOOD_CESS | number:'1.2-2'  }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.TOTAL | number:'1.2-2'  }}
                </td>
              </tr>
              </tbody>
            </table>

            <!--totals-->
            <table style="width: 100%;border: 0;border-collapse: collapse;border-radius: 0;">
              <tbody>
              <tr style="border-right: 1px solid #343a40;border-left: 1px solid #343a40;">
                <td colspan="2"
                    style="padding: 5px !important;font-size: 16px;text-align: right;">
                  Gross amount&nbsp;&nbsp;:
                  &nbsp;&nbsp;{{ gross | number : '1.2-2' }}
                  <ng-container *ngIf="saled && saled.DISCOUNT > 0">
                    <br>
                    Discount &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.DISCOUNT }}
                  </ng-container>
                  <ng-container *ngIf="saled && saled.FREIGHT_CHARGE > 0">
                    <br>
                    Freight/Handling charge &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.FREIGHT_CHARGE }}
                  </ng-container>
                </td>
              </tr>
              <tr style="border: 1px solid #000;">
                <td colspan="2"
                    style="padding: 5px !important;font-weight: bolder;font-size:18px;text-align: right;">
                  Net bill amount (KWD): {{ price_total | number : '1.2-2' }}
                </td>
              </tr>
              <tr style="border: 1px solid #000;">
                <td
                  style="padding: 5px !important;text-transform:capitalize;font-size: 12px !important;text-align: left;">
                  Amount in
                  words &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ numberToWords }} &nbsp;Rupees
                  only&nbsp;
                </td>
                <td style="padding: 5px !important;font-size: 12px !important;text-align: right">You saved
                  Rs {{ save_rate }}/-
                </td>

              </tr>
              </tbody>
            </table>
          </div>
          <!--shipping details-->
          <div *ngIf="saled.SHIPPING_ADDRESS" style="display:grid;margin-top: 15px;">
            <p style="margin: 0;font-size: 14px;font-weight: bold">Shipping Address&nbsp;&nbsp;</p>
            <p [innerHTML]='saled.SHIPPING_ADDRESS | nl2br ' style="margin: 0;font-size: 14px;"></p>
          </div>

          <!--account details-->
          <div style="display:grid;margin-top: 15px;">
            <p style="margin: 0;font-size: 14px;font-weight: bold">Account details&nbsp;&nbsp;</p>
            <p style="margin: 0;font-size: 14px;line-height: 20px">
                WFL United General Trading Company,<br>
                Gulf Bank, 94818570, GULBKWKW,<br>
              KW32GULB0000000000000094818570<br>
            </p>
          </div>
          <!-- footer-->
          <div
            style="font-size: 12px;padding: 15px;text-align: center;width: 100%;position: absolute;bottom: 15px;left: 0;right: 0;">
            This is a computer-generated
            document.
            No signature is required.
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #files let-modal>
  <div *ngIf="file_list" class="modal-header">
    <div class="pull-right">
      <h4 class="modal-title" id="modal-basic-title">
        Attachment List
      </h4>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="file_list">
      <ng-container *ngFor="let file of file_list">
        <div class="col-2"></div>
        <div class="col-10">
          <div><a href="{{ attachmentPath(file.ATTACHMENT_TITLE) }}" target="_blank"
                  title="{{ file.ATTACHMENT_TITLE }}"><i class="fa fa-file"></i>&nbsp;&nbsp;{{ file.ATTACHMENT_TITLE }}</a>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!file_list">
      <div class="text-center text-danger">No attachment in this sale.
        <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </ng-container>
  </div>

</ng-template>

<ng-template #payment let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Payment Credit
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="row">
          <div class=" col-lg-5">
            <label>Payment Credit</label>
          </div>
          <div class=" col-lg-7">
            <label class="checkbox-inline">
              <input (click)="selectpaymentcredit(1)" [checked]="sale_credit.payment_credit == 1" id="Yes"
                     name="payment_price" type="radio"
                     value="1">&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </label>
            <label class="checkbox-inline">
              <input (click)="selectpaymentcredit(0)" [checked]="sale_credit.payment_credit == 0" id="No"
                     name="payment_price" type="radio"
                     value="0">&nbsp;&nbsp;No
            </label>
          </div>
          <div class="clearfix"></div>
          <div class=" col-lg-5">
            <label>Received Amount</label>
          </div>
          <div class=" col-lg-7">
            <input [(ngModel)]="sale_credit.payment_received" [disabled]="sale_credit.payment_credit == 0"
                   class="form-control " id="payment_received" name="payment_received"
                   type="text">
          </div>
          <div class="clearfix"></div>
          <div class=" col-lg-5">
            <label for="date">Credit Date</label>
          </div>
          <div class=" col-lg-7">
            <input (ngModelChange)="sale_credit.credit_date = $event" [disabled]="sale_credit.payment_credit == 0"
                   [max]="getToday()" [ngModel]="sale_credit.credit_date | date:'yyyy-MM-dd' "
                   class="form-control " id="credit_date" name="credit_date"
                   type="date">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="form-group text-center col-lg-12">
          <button (click)="modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                  class="btn-warning btn  btn-sm ng-star-inserted" style="color:#fff">Cancel
          </button>&nbsp;&nbsp;&nbsp;
          <button (click)="savepaymentCredit(payment);modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                  class="btn-info btn  btn-sm ng-star-inserted">Save
          </button>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sendmail let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Send to mail
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="row">
          <div class=" col-lg-3">
            <label>To mail</label>
          </div>
          <div class="col-lg-9">
            <input [(ngModel)]="to_mail_address" class="form-control " id="" maxlength="50" name="email"
                   type="text">
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="form-group text-center col-lg-12">
          <button (click)="modal.dismiss('Cross click')" class="btn-danger btn btn-sm"
                  style="color:#fff">Cancel
          </button>&nbsp;&nbsp;&nbsp;
          <button (click)="sendToMail(sendmail);modal.dismiss('Cross click')"
                  class="btn-info btn btn-sm">Send
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #copydata let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h3 id="modal-basic-title">
        Copy Sales Details
      </h3>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <ng-template #rt let-r="result" let-t="term">
          <ngb-highlight [result]="r.HSN_CODE+'  '+r.DDC_CODE+' - '+r.TRADE_NAME" [term]="t"></ngb-highlight>
        </ng-template>
        <div *ngIf="user_rights.ADD == '1'" class="page-panel">
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="row">
            <div class="form-group col-lg-3">
              <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
              <input [ngModel]="sale.customer" [readonly]="true" class="form-control "
                     id="customer" name="customer" type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>Date</label><span class="text-danger">&nbsp;*</span>
              <input (ngModelChange)="sale.sale_date = $event" [max]="getToday()"
                     [ngModel]="sale.sale_date | date:'yyyy-MM-dd'" class="form-control "
                     id="date" name="date" type="date">
            </div>
            <div class="form-group col-lg-3">
              <label>Order No</label><span class="text-danger">&nbsp;*</span>
              <input [(ngModel)]="sale.order_no" class="form-control " maxlength="10" name="order_no"
                     readonly="readonly"
                     tabindex="-1" type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>VAT No</label>
              <input [(ngModel)]="sale.vat_no" [readOnly]="true" class="form-control " maxlength="10"
                     name="vat_no" type="text">
            </div>
            <div *ngIf="sale.customer_address != ''" class="form-group col-lg-3">
              <label>Customer Address</label>
              <textarea [(ngModel)]="sale.customer_address" class="form-control " name="address"
                        readonly style="font-size: 12px;"></textarea>
            </div>
            <div class="form-group col-lg-3">
              <label>State</label><span class="text-danger">&nbsp;*</span>
              <input [(ngModel)]="sale.state" [readOnly]="true" class="form-control " maxlength="10"
                     name="state"
                     type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>Slab</label>
              <select (change)="cleardata()" [(ngModel)]="sale.slab"
                      class="form-control  custom-select custom-select-sm" id="sel_dr"
                      name="sel_dr">
                <option value="">Select Slab</option>
                <option value="1">Slab A</option>
                <option value="2">Slab B</option>
                <option value="3">Slab C</option>
              </select>
            </div>
            <div class="form-group col-lg-3">
              <label>Payment Type</label>
              <div class="col-12">
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(1)" [checked]="sale.payment_type == 1" id="cash"
                         name="payment_type"
                         type="radio" value="1">&nbsp;&nbsp;Cash&nbsp;&nbsp;
                </label>&nbsp;&nbsp;&nbsp;
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(0)" [checked]="sale.payment_type == 0" id="card"
                         name="payment_type"
                         type="radio" value="0">&nbsp;&nbsp;Card&nbsp;&nbsp;
                </label>&nbsp;&nbsp;&nbsp;
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(2)" [checked]="sale.payment_type==2" id="cheque"
                         name="payment_type" type="radio"
                         value="2">&nbsp;&nbsp;Cheque&nbsp;&nbsp;
                </label>
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(3)" [checked]="sale.payment_type==3" id="bank"
                         name="payment_type"
                         type="radio" value="3">&nbsp;&nbsp;Bank
                </label>
                <ng-container *ngIf="sale.payment_type==2">
                  <input [(ngModel)]="sale.chequeno" class="form-control " maxlength="20" name="cheque"
                         placeholder="Enter cheque number" type="text">
                </ng-container>
                <ng-container *ngIf="sale.payment_type == 0">
                  <input [(ngModel)]="sale.chequeno" class="form-control " maxlength="20" name="cheque"
                         placeholder="Enter card number" type="text">
                </ng-container>
              </div>
            </div>
            <div class="form-group col-lg-3">
              <label>Drug License Number</label>
              <input [(ngModel)]="sale.license_no" [readOnly]="true" class="form-control "
                     name="license_no"
                     type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>Shipping Address</label>
              <textarea [(ngModel)]="sale.shipping_address" class="form-control "
                        name="shipping_address" style="font-size: 12px;"></textarea>
            </div>
            <div class="form-group col-lg-3">
              <label>Remarks</label>
              <input [(ngModel)]="sale.remark" class="form-control " name="remark"
                     type="text">
            </div>
          </div>
          <hr>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="col-lg-12 ">
            <table class=" table   table-bordered">
              <thead>
              <tr class="text-center">
                <th>FOC</th>
                <th>#Sl</th>
                <th width="25%">Item Information<span class="text-danger">&nbsp;*</span></th>
                <th>Warehouse<span class="text-danger">&nbsp;*</span></th>
                <th>Ava.Qty</th>
                <th width="8%">UOM</th>
                <th>MRP</th>
                <th>Retail Price</th>
                <th width="7%">Quantity<span class="text-danger">&nbsp;*</span></th>
                <ng-container *ngIf="sale.state!== ''">
                  <th colspan="2">VAT <span class="text-danger">&nbsp;*</span><br>
                    <span>%</span><span class="pull-right">Amount</span>
                  </th>
                </ng-container>
                <th>Total<span class="text-danger">&nbsp;*</span></th>
                <th>*</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let i of utils.buildArray(sale_details.length)">
                <td class="text-center">
                  <label>
                    <input (change)="giveMarkFOC(i)" [(ngModel)]="sale.mark_free_of_cost[i]"
                           [checked]="sale.mark_free_of_cost[i] == true"
                           name="mark_free_of_cost{{i}}"
                           type="checkbox"/>
                  </label>
                </td>
                <td class="text-center">{{ 1 + i }}</td>
                <td>
                  <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="sale.medicine_data[i]"
                         [class.is-invalid]="searchFailed" [inputFormatter]="formatter"
                         [ngModelOptions]="{standalone: true}"
                         [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
                         class="form-control" id="typeahead-http{{i}}"
                         placeholder="Search Particular Name...." style="height: 29px;"
                         type="text"/>
                </td>
                <td>
                  <select (change)="availableqty(i)"
                          [(ngModel)]="sale.warehouse_details_id_arr[i]"
                          class="form-control  custom-select custom-select-sm"
                          name="warehouse_id">
                    <option value=0>Select Warehouse</option>
                    <option *ngFor="let data of sale.warehouses_data[i];"
                            value="{{data.WAREHOUSE_STOCK_DETAIL_ID}}">{{ data.WAREHOUSE }}
                    </option>
                  </select>
                </td>
                <td>
                  <input [(ngModel)]="sale.ava_quantity_arr[i]" [readOnly]="true"
                         class="form-control text-center "
                         name="ava_quantity_arr{{i}}" tabindex="-1"
                         type="text">
                </td>
                <td>
                  <input [(ngModel)]="sale.uom_arr_name[i]" [readOnly]="true" class="form-control  "
                         name="uom_arr_name{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <input [(ngModel)]="sale.MRP[i]" [readOnly]="true" class="form-control text-right "
                         name="MRP{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <input (focusout)="totalAmount();totalprice();"
                         [(ngModel)]="sale.unitprice_arr[i]"
                         [disabled]="sale.mark_free_of_cost[i] == true" class="form-control text-right "
                         name="unitprice_arr{{i}}" type="text">
                </td>
                <td>
                  <input (focusout)="totalprice();totalAmount()"
                         [(ngModel)]="sale.quantity_arr[i]" class="form-control  " maxlength="7"
                         name="quantity_arr{{i}}" type="text">
                </td>
                
                <ng-container *ngIf="sale.state!== ''">
                  <td>
                    <input (focusout)="totalprice()" [(ngModel)]="sale.vat_arr[i]" [readOnly]="true"
                           class="form-control text-right " name="vat_arr{{i}}"
                           tabindex="-1" type="text">
                  </td>
                  <td>
                    <input (focusout)="totalprice()" [(ngModel)]="sale.vatamt_arr[i]" [readOnly]="true"
                           class="form-control text-right " name="vatamt_arr{{i}}"
                           tabindex="-1" type="text">
                  </td>
                </ng-container>
                <td>
                  <input [(ngModel)]="sale.total_arr[i]" [readOnly]="true"
                         class="form-control text-right "
                         name="total_arr{{i}}" tabindex="-1"
                         type="text">
                </td>
                <td>
                  <button (click)="addrow(i)" *ngIf="i == sale_details.length-1"
                          alt="Add New data" class="btn btn-success btn-sm " title="Add New data"
                          type="button"><i class="fa fa-plus"
                                           style="color: white;"></i></button>
                  <button (click)="deleterow(i)" *ngIf="i  !== sale_details.length-1" alt="Delete data"
                          class="btn btn-danger  btn-sm " title="Delete data"
                          type="button"><i class="fa fa-trash" style="color: white;"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <ng-container *ngIf="sale.state!== ''">
                <tr>
                  <td colspan="13" style="text-align: right"><label>Gross
                    Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{
                      total_amount | number :
                        '1.2-2'
                    }}</label></td>
                </tr>
                <tr>
                  <td colspan="7" style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp;
                  </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.discount"
                         class="form-control text-right "
                         maxlength="8" name="dis_arr"
                         style="height:34px" type="text">
                  <td colspan="2" style="text-align: right"><label>Freight/Handling
                    charge&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.freight_charge"
                         class="form-control text-right "
                         maxlength="9"
                         name="freight" style="height:34px"
                         type="text">
                  <td colspan="2" style="text-align: right"><label>Net
                    Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{
                      net_total | number :
                        '1.2-2'
                    }}</label></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="sale.state!== ''">
                <tr>
                  <td colspan="11" style="text-align: right"><label>Gross
                    Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{
                      total_amount | number :
                        '1.2-2'
                    }}</label></td>
                </tr>
                <tr>
                  <td colspan="6" style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp;
                  </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.discount"
                         class="form-control text-right "
                         maxlength="8" name="dis_arr"
                         style="height:34px" type="text">
                  <td colspan="2" style="text-align: right"><label>Freight/Handling
                    charge&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.freight_charge"
                         class="form-control text-right " maxlength="9"
                         name="freight" style="height:34px"
                         type="text">
                  <td style="text-align: right"><label>Net Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{
                      net_total | number :
                        '1.2-2'
                    }}</label></td>
                </tr>
              </ng-container>
              </tfoot>
            </table>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="row container">
            <div class="col-lg-7 pull-right">
              <button (click)="saveSale()" class="btn  btn-info btn-sm ng-star-inserted"
                      type="button">&nbsp;Save&nbsp;
              </button>&nbsp;&nbsp;
            </div>
          </div>
          <div style="height:100px"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #cancelreason let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h5 class="modal-title" id="modal-basic-title">
        Cancel Reason
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
        <textarea [(ngModel)]="cancel_reason" class="form-control" name="return_reson"
                  style="height: 120px;"></textarea>

  </div>
  <div class="model-footer">
    <div class="clearfix"></div>
    <div class="form-group text-center col-lg-12">
      <button (click)="modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'" class="btn-danger btn  btn-sm "
              style="color:#fff">Cancel
      </button>&nbsp;&nbsp;&nbsp;
      <button (click)="cancelInvoice(cancelreason);modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
              class="btn-info btn  btn-sm ">Save
      </button>
    </div>
  </div>
</ng-template>
